import { SHIPMENT_STAGES } from '../model/stages'
import type { ShipmentStage } from '../model/stages'

export interface StageRoute {
  to: string
  paramKey: string
}

export const STAGE_ROUTE: Record<ShipmentStage, StageRoute> = {
  [SHIPMENT_STAGES.LEAD]: { to: '/leads/$leadId', paramKey: 'leadId' },
  [SHIPMENT_STAGES.QUOTE]: { to: '/quotes/$quoteId', paramKey: 'quoteId' },
  [SHIPMENT_STAGES.ORDER]: { to: '/orders/$orderId', paramKey: 'orderId' },
}

export const STAGE_EDIT_ROUTE: Record<ShipmentStage, StageRoute> = {
  [SHIPMENT_STAGES.LEAD]: { to: '/leads/$leadId/edit', paramKey: 'leadId' },
  [SHIPMENT_STAGES.QUOTE]: { to: '/quotes/$quoteId/edit', paramKey: 'quoteId' },
  [SHIPMENT_STAGES.ORDER]: { to: '/orders/$orderId/edit', paramKey: 'orderId' },
}

export const STAGE_CONVERT_ROUTE: Partial<Record<ShipmentStage, StageRoute>> = {
  [SHIPMENT_STAGES.LEAD]: { to: '/leads/$leadId/convert', paramKey: 'leadId' },
  [SHIPMENT_STAGES.QUOTE]: {
    to: '/quotes/$quoteId/convert',
    paramKey: 'quoteId',
  },
}

export const ORDER_DISPATCH_ROUTE: StageRoute = {
  to: '/orders/$orderId/dispatch',
  paramKey: 'orderId',
}

const STAGE_VALUES: ReadonlySet<string> = new Set(
  Object.values(SHIPMENT_STAGES),
)

export function isShipmentStage(value: string): value is ShipmentStage {
  return STAGE_VALUES.has(value)
}
